import { styled } from "@mui/system";
import { Button } from "@mui/material";

const PrimaryButton = styled(Button)`
  && {
    background: #004795;
    color: #ffffff;
    border-radius: 50px; 
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
    text-transform: none; 
    font-weight: 500;
    font-size: 1rem;
    min-width: 18rem;
    width: 14rem;
    padding: 0.8rem 2.5rem;
    
    &:hover {
      background-color: #003366;
      box-shadow: 0px 6px 12px rgba(0, 0, 0, 0.15);
    }

    &:disabled {
      background-color: #e0e0e0;
      color: #a0a0a0;
    }
    @media (max-width: 600px) {
      width: 100%;
      min-width: 0;
    }
  }
`;

export default PrimaryButton;